<template>
  <footer class="footer pt-0 footer-dark">
    <div class="footer-icon">
      <div class="container">
        <div class="row">
          <div class="col-6 col-md-3">
            <div class="desc-item">
              <img class="desc-item-img" src="/templates/scgidc/img/footer/footer-icon-1.svg" alt="24/7 Premium Support" />
              <div class="desc-item-text">
                <p class="title">{{ t('footer.support247') }}</p>
                <p class="desc">{{ t('footer.premiumSupport') }}</p>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="desc-item">
              <img class="desc-item-img" src="/templates/scgidc/img/footer/footer-icon-2.svg" alt="New User Free Trials" />
              <div class="desc-item-text">
                <p class="title">{{ t('footer.newUser') }}</p>
                <p class="desc">{{ t('footer.freeTrials') }}</p>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="desc-item">
              <img class="desc-item-img" src="/templates/scgidc/img/footer/footer-icon-3.svg" alt="Always On Expert Guidance" />
              <div class="desc-item-text">
                <p class="title">{{ t('footer.alwaysOn') }}</p>
                <p class="desc">{{ t('footer.expertGuidance') }}</p>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="desc-item">
              <img class="desc-item-img" src="/templates/scgidc/img/footer/footer-icon-6.svg" alt="Reliable 99.95% Uptime" />
              <div class="desc-item-text">
                <p class="title">{{ t('footer.reliable') }}</p>
                <p class="desc">{{ t('footer.uptime') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="footer-top">
        <div class="row">
          <div class="col-md-3 footer-col">
            <div class="footer-company-info">
              <router-link to="/" class="logo d-flex align-items-center">
                <img src="/templates/scgidc/img/logo-white.svg" alt="" class="footer-logo">
              </router-link>
              <p>{{ t('footer.companyDesc') }}</p>
              <!-- 社交媒体链接 -->
              <div class="social-links">
                <a href="https://twitter.com/nebula_global" target="_blank" class="social-btn" title="Twitter / X">
                  <PhTwitterLogo :size="18" weight="fill" />
                </a>
                <a href="https://facebook.com/nebula.global" target="_blank" class="social-btn" title="Facebook">
                  <PhFacebookLogo :size="18" weight="fill" />
                </a>
                <a href="https://linkedin.com/company/nebula-global" target="_blank" class="social-btn" title="LinkedIn">
                  <PhLinkedinLogo :size="18" weight="fill" />
                </a>
                <a href="https://discord.gg/nebula" target="_blank" class="social-btn" title="Discord">
                  <PhDiscordLogo :size="18" weight="fill" />
                </a>
                <a href="https://t.me/nebula_global" target="_blank" class="social-btn" title="Telegram">
                  <PhTelegramLogo :size="18" weight="fill" />
                </a>
              </div>
            </div>
          </div>

          <div class="col footer-col" @click="toggleFooterCol($event)">
            <h4 class="h5">{{ t('footer.companyIntro') }}</h4>
            <ul class="list-unstyled">
              <li><router-link to="/company">{{ t('footer.aboutUs') }}</router-link></li>
              <li><router-link to="/joinus">{{ t('footer.joinUs') }}</router-link></li>
              <li><a href="https://95008.com/news/">{{ t('footer.industryNews') }}</a></li>
            </ul>
          </div>

          <div class="col footer-col" @click="toggleFooterCol($event)">
            <h4 class="h5">{{ t('footer.support') }}</h4>
            <ul class="list-unstyled">
              <li><a href="">{{ t('footer.contactSales') }}</a></li>
              <li><router-link to="/submitticket">{{ t('footer.openTicket') }}</router-link></li>
              <li><a href="https://95008.com/clientarea.php">{{ t('footer.tickets') }}</a></li>
              <li><router-link to="/download">{{ t('footer.searchDownloads') }}</router-link></li>
              <li><router-link to="/docs">{{ t('footer.knowledgebase') }}</router-link></li>
              <li><router-link to="/announcements">{{ t('footer.announcements') }}</router-link></li>
              <li><a href="https://95008.com/clientarea.php">{{ t('footer.networkStatus') }}</a></li>
            </ul>
          </div>

          <div class="col footer-col" @click="toggleFooterCol($event)">
            <h4 class="h5">{{ t('footer.billing') }}</h4>
            <ul class="list-unstyled">
              <li><a href="https://95008.com/clientarea.php">{{ t('footer.invoices') }}</a></li>
              <li><a href="https://95008.com/clientarea.php">{{ t('footer.quotes') }}</a></li>
              <li><a href="https://95008.com/clientarea.php">{{ t('footer.paymentMethod') }}</a></li>
              <li><a href="https://95008.com/clientarea.php">{{ t('footer.addFunds') }}</a></li>
              <li><router-link to="/cart">{{ t('footer.viewCart') }}</router-link></li>
            </ul>
          </div>

          <div class="col footer-col" @click="toggleFooterCol($event)">
            <h4 class="h5">{{ t('footer.accountOverview') }}</h4>
            <ul class="list-unstyled">
              <li><a href="https://95008.com/clientarea.php">{{ t('footer.manageAccount') }}</a></li>
              <li><a href="https://95008.com/clientarea.php">{{ t('footer.paymentMethod') }}</a></li>
              <li><a href="https://95008.com/clientarea.php">{{ t('footer.userManagement') }}</a></li>
              <li><a href="https://95008.com/clientarea.php">{{ t('footer.accountSecurity') }}</a></li>
            </ul>
          </div>

          <div class="col col-md-3 footer-col">
            <h4 class="h5">{{ t('footer.hotline') }}</h4>
            <ul class="list-unstyled">
              <li><PhHouse :size="16" weight="regular" class="mr-2" />{{ t('footer.companyName') }}</li>
              <li><PhMapPin :size="16" weight="regular" class="mr-2" />{{ t('footer.companyAddress') }}</li>
              <li><PhEnvelope :size="16" weight="regular" class="mr-2" />{{ companyEmail }}</li>
              <li><PhPhone :size="16" weight="regular" class="mr-2" />{{ t('footer.companyPhone') }}</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <div class="footer-bottom-left">
          <p class="copyright-text">
            {{ t('footer.copyright') }}
          </p>
        </div>
        <div class="footer-bottom-center">
          <ul class="legal-links">
            <li><router-link to="/legal/tos">{{ t('footer.termsOfService') }}</router-link></li>
            <li><router-link to="/legal/privacy-policy">{{ t('footer.privacyPolicy') }}</router-link></li>
            <li><router-link to="/legal/acceptable-use-policy">{{ t('footer.acceptableUsePolicy') }}</router-link></li>
            <li><router-link to="/legal/dsa-policy">{{ t('footer.dsaPolicy') }}</router-link></li>
            <li><router-link to="/legal/dmca-policy">{{ t('footer.dmcaPolicy') }}</router-link></li>
          </ul>
        </div>
        <div class="footer-bottom-right">
          <!-- 语言切换下拉菜单 -->
          <a-dropdown trigger="click" @select="handleLangSelect" position="top">
            <div class="language-switch">
              <img src="https://assets.byteplus.com/obj/byteplus-assets/navigation/icon-language-white.svg" width="18" height="18" alt="language" />
              <span>{{ getLangName(lang) }}</span>
            </div>
            <template #content>
              <a-doption v-for="l in langList" :key="l" :value="l" :class="{ 'lang-option-active': l === lang }">
                {{ getLangName(l) }}
              </a-doption>
            </template>
          </a-dropdown>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { computed, onMounted, onBeforeMount, onErrorCaptured, ref } from 'vue'
import { useI18n } from '@/locales'
import { getEmail, getCompanyInfo, getCopyright } from '@/utils/config'
import { 
  PhTwitterLogo, 
  PhFacebookLogo, 
  PhLinkedinLogo, 
  PhDiscordLogo, 
  PhTelegramLogo,
  PhHouse,
  PhMapPin,
  PhEnvelope,
  PhPhone
} from '@phosphor-icons/vue'

console.log('=== Footer组件脚本执行 ===')

// 错误捕获
onErrorCaptured((err, instance, info) => {
  console.error('=== Footer组件错误 ===')
  console.error('错误:', err.message)
  console.error('位置:', info)
  return false
})

onBeforeMount(() => {
  console.log('=== Footer组件 beforeMount ===')
})

onMounted(() => {
  console.log('=== Footer组件 mounted ===')
  console.log('Footer DOM元素:', document.querySelector('footer'))
})

let t, lang, setLang, langList, getLangName

try {
  console.log('尝试获取i18n...')
  const i18nResult = useI18n()
  t = i18nResult.t
  lang = i18nResult.lang
  setLang = i18nResult.setLang
  langList = i18nResult.langList
  getLangName = i18nResult.getLangName
  console.log('✓ i18n获取成功')
  
  // 测试一个简单的翻译
  try {
    const testTranslation = t('footer.support247')
    console.log('测试翻译 footer.support247:', testTranslation)
  } catch (e) {
    console.error('翻译测试失败:', e.message)
  }
} catch (error) {
  console.error('!!! useI18n失败:', error.message)
  console.error('错误栈:', error.stack)
  
  // 提供fallback
  t = (key) => {
    console.warn(`翻译失败: ${key}`)
    return key
  }
  lang = ref('en')
  setLang = () => {}
  langList = ['en']
  getLangName = (l) => l
}

const currentYear = computed(() => new Date().getFullYear())

// 从配置文件获取公司邮箱
const companyEmail = computed(() => getEmail('support'))

function handleLangSelect(value) {
  setLang(value)
  // 语言切换使用Vue响应式系统，无需刷新页面
}

function toggleFooterCol(event) {
  const footerCol = event.currentTarget
  footerCol.classList.toggle('active')
  const list = footerCol.querySelector('.list-unstyled')
  if (list) {
    list.classList.toggle('active')
  }
}
</script>

<style scoped>
/* Footer背景色 */
.footer-dark {
  background-color: #000 !important;
}

/* 底部菜单文字颜色 */
.footer-dark .list-unstyled li a,
.footer-dark .list-unstyled li {
  color: rgba(255, 255, 255, 0.7) !important;
  display: flex;
  align-items: center;
}
.footer-dark .list-unstyled li .mr-2 {
  margin-right: 8px;
  flex-shrink: 0;
}
.footer-dark .list-unstyled li a:hover {
  color: #fff !important;
}
.footer-dark .h5 {
  color: rgba(255, 255, 255, 0.9) !important;
}
.footer-dark .footer-company-info p {
  color: rgba(255, 255, 255, 0.7) !important;
}

/* Footer Logo 尺寸 */
.footer-logo {
  width: 180px !important;
  height: auto !important;
  max-width: 100%;
}

/* 社交媒体链接 */
.social-links {
  display: flex;
  gap: 12px;
  margin-top: 16px;
}
.social-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: all 0.3s;
}
.social-btn :deep(svg) {
  width: 18px;
  height: 18px;
}
.social-btn:hover {
  background: #165DFF;
  border-color: #165DFF;
  color: #fff;
  transform: translateY(-2px);
}

.footer-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0;
  border-top: 1px solid rgba(255,255,255,0.1);
}
.footer-bottom-left {
  flex-shrink: 0;
}
.copyright-text {
  margin: 0;
  color: rgba(255, 255, 255, 0.5);
  font-size: 13px;
}
.footer-bottom-center {
  flex: 1;
  display: flex;
  justify-content: center;
}
.legal-links {
  display: flex;
  align-items: center;
  gap: 8px;
  list-style: none;
  margin: 0;
  padding: 0;
}
.legal-links li {
  position: relative;
  padding-right: 8px;
}
.legal-links li:not(:last-child)::after {
  content: '|';
  position: absolute;
  right: 0;
  color: rgba(255, 255, 255, 0.3);
}
.legal-links li:last-child {
  padding-right: 0;
}
.legal-links a {
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
  text-decoration: none;
  transition: color 0.2s;
}
.legal-links a:hover {
  color: #fff;
}
.footer-bottom-right {
  flex-shrink: 0;
}

/* 语言切换按钮 */
.language-switch {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 20px;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  transition: all 0.3s;
}
.language-switch:hover {
  border-color: rgba(255,255,255,0.6);
  color: #fff;
  background: rgba(255,255,255,0.05);
}

/* 语言选项高亮 */
:deep(.lang-option-active) {
  color: #165dff !important;
  font-weight: 500;
  background: rgba(22, 93, 255, 0.1) !important;
}

@media (max-width: 992px) {
  .footer-bottom {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }
  .footer-bottom-center {
    order: 2;
  }
  .footer-bottom-right {
    order: 3;
  }
  .legal-links {
    flex-wrap: wrap;
    justify-content: center;
  }
}
</style>
